



































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { InputField, InputType } from '@/components/ui/DynamicTechTaskCard/types'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import ComboboxInputField from '@/dynamic-tech-task/components/input/ComboboxInputField.vue'
import DisplayFields from '@/components/ui/DynamicTechTaskCard/DisplayFields.vue'
import DropdownInputField from '@/dynamic-tech-task/components/input/DropdownInputField.vue'
import MultiDropdownInputField from '@/dynamic-tech-task/components/input/MultiDropdownInputField.vue'
import OrderedListField from '@/dynamic-tech-task/components/input/OrderedListField.vue'
import { OrderedListOptions } from '@/components/ui/DynamicTechTaskCard/types/input-field'
import RadioInputField from '@/dynamic-tech-task/components/input/RadioInputField.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


@Component({
    name: 'DynamicForm',
    components: {
        AccountIdInput,
        ComboboxInputField,
        DisplayFields,
        DropdownInputField,
        MultiDropdownInputField,
        OrderedListField,
        RadioInputField,
        TechTaskCard
    }
})
export default class DynamicForm extends Vue {
    @Prop() disabled!: boolean
    @Prop() loading!: boolean
    @Prop() accountIdDisabled!: boolean
    @Prop() inputFields!: InputField[]
    InputType = InputType

    get taskName() {
        return this.$store.state.techTask.taskName
    }

    get inputData() {
        return this.$store.state.techTask.inputData
    }

    get filteredInputFields(): InputField[] {
        const additionalFields: string[] = []
        for (const inputField of this.inputFields) {
            const inputOptions = inputField.inputOptions as OrderedListOptions
            if (inputOptions?.additionalFields !== undefined) {
                additionalFields.push(...inputOptions.additionalFields)
            }
        }
        return this.inputFields.filter((inputField: InputField) => {
            return additionalFields.indexOf(inputField.key) === -1
        })
    }

    /**
     * This is how we are required to update keys inside of inputData since it is a nested value.
     */
    onInput(key: string, value: unknown) {
        this.$store.dispatch('setInputData', { key, value })
    }

    @Emit('onLocationChange')
    onLocationChange(locationValid: boolean) {
        return locationValid
    }

    additionalFields(inputField: InputField): InputField[] {
        const inputOptions = inputField.inputOptions as OrderedListOptions
        if (inputOptions && inputOptions.additionalFields) {
            const additionalFields: string[] = inputOptions.additionalFields
            return this.inputFields.filter((inputField: InputField) => {
                return additionalFields.indexOf(inputField.key) !== -1
            })
        } else {
            return []
        }
    }
}
